/**
 * @file paddle model center 首页
 * @author wanzhongyun
 */
import React from 'react';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import ModelCenter from './ModelCenter';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './style.less';

Cookies.set('lang', 'zh_CN', { expires: 7, path: '/' });
Cookies.set('ai-studio-lc', 'zh_CN', { expires: 7, path: '/' });
moment.locale('zh-cn');

ReactDOM.render(<ModelCenter />, document.getElementById('root'));
